import Accordion from 'entities/Accordion'
import { Button } from 'entities/Button'
import { Input } from 'entities/Input'
import { Select } from 'entities/Select'
import { useEffect, useMemo, useState } from 'react'
import { getGuid } from 'shared/helpers/getGUID'
import { useBranchStore } from 'shared/store/branchesSlice'

export const URLBuilderAccordion = () => {
  const branchList = useBranchStore().branchList

  const [selectedBranchId, setSelectedBranch] = useState(0)
  const [linkValue, setLinkValue] = useState('')

  useEffect(() => {
    handleLinkValue()
  }, [selectedBranchId])

  const branchListForUrlBuilder = useMemo(() => {
    return [
      { value: 0, label: 'Without branch' },
      ...branchList.map(el => ({ value: el.Intern, label: el.Bezeichnung }))
    ]
  }, [branchList])

  const handleLinkValue = async () => {
    const company = await getGuid()
    const value = (function () {
      switch (true) {
        case !!company?.length && !!selectedBranchId:
          return `${process.env.REACT_APP_QRMENU_URL}/booking?guid=${company}&branchId=${selectedBranchId}`
        case !!company?.length && !selectedBranchId:
          return `${process.env.REACT_APP_QRMENU_URL}/booking?guid=${company}`
        case !company:
          return ''
      }
    })()
    setLinkValue(value || '')
  }

  const copyUrlToClipBoard = () => {
    // TODO: toaster
    navigator.clipboard.writeText(linkValue)
  }

  return (
    <Accordion title='URL Builder'>
      <Select
        label='Branch'
        options={branchListForUrlBuilder}
        onChange={value => setSelectedBranch(+value)}
        value={selectedBranchId}
      />
      <Input value={linkValue} disabled fullWidth sx={{ margin: '20px 0' }} />
      <Button handleClick={copyUrlToClipBoard} width='100%' height='56px'>
        Copy to clipboard
      </Button>
    </Accordion>
  )
}
